import Banner from '@zenbusiness/zui/Banner';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import { useNavigate } from 'react-router-dom';

import StickyBoxContainer from '#client/components/StickyBoxContainer';
import { DB_APPLICATION_STATUS } from '#client/constants/application';
import { RELEASE_PREVENT_BANNER_COVER_UP_TEXT } from '#client/constants/experimentsFlags';
import { MODAL_NAMES } from '#client/constants/modals';
import useApplicationStatusContext from '#client/hooks/useApplicationStatusContext';
import useFeatureFlag from '#client/hooks/useFeatureFlag';
import useSCorpBankingPrice from '#client/hooks/useSCorpBankingPrice';
import {
  defaultPayloadBannerDisplayed,
  defaultPayloadButtonPressed
} from '#client/hooks/useTrackEvent';

export default function FinishApplicationBanner() {
  const navigate = useNavigate();
  const { appStatus } = useApplicationStatusContext();
  const [isEnablePreventBannerCoverUpText, isLoadingFlag] = useFeatureFlag(
    RELEASE_PREVENT_BANNER_COVER_UP_TEXT
  );

  const { bankingPrice } = useSCorpBankingPrice();

  const createHandleNavigateFinishApplication = () => {
    navigate(`?modal=${MODAL_NAMES.APPLICATION_INIT_MODAL}`, { replace: true });
  };

  const isShowBanner = [
    DB_APPLICATION_STATUS.NOT_STARTED,
    DB_APPLICATION_STATUS.STARTED,
    DB_APPLICATION_STATUS.INCOMPLETE,
    DB_APPLICATION_STATUS.EXPIRED,
    DB_APPLICATION_STATUS.AWAITING_CHECKOUT
  ].includes(appStatus);

  return isShowBanner && !isLoadingFlag ? (
    <StickyBoxContainer isShiftable={!isLoadingFlag && isEnablePreventBannerCoverUpText}>
      <Banner
        clickstreamProps={{
          bannerDisplayed: {
            ...defaultPayloadBannerDisplayed,
            bannerType: 'promo',
            elementName: 'Apply_for_banking',
            appPageName: 'active_banking_dashboard'
          }
        }}
        slotProps={{
          primaryAction: {
            label:
              appStatus === DB_APPLICATION_STATUS.NOT_STARTED ? 'Apply now' : 'Finish Application',
            clickstreamProps: {
              ...defaultPayloadButtonPressed,
              elementText:
                appStatus === DB_APPLICATION_STATUS.NOT_STARTED
                  ? 'Apply now'
                  : 'Finish Application',
              elementName: 'Apply_now_bottom_banner',
              appPageName: 'banking_upsell_dashboard'
            },
            onClick: createHandleNavigateFinishApplication
          }
        }}
        slots={{
          startIcon: (
            <SharedAsset
              alt=""
              src="/s2/vector/product-zb-banking.svg"
            />
          )
        }}
        subtitle={`Get business checking for ${bankingPrice}, and no minimum deposit or balance to keep.`}
        title="Bank with ZenBusiness"
        variant="promo"
      />
    </StickyBoxContainer>
  ) : null;
}
